import withValueHOC from "@common/hocs/withValue";

export * from "@common/hocs/withValue";

export default withValueHOC;
